import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';
import map from 'lodash/map';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import type { StepTrustHeaderText } from '../../../../utils/step_header_text';

export interface StepTrustHeaderProp {
  className?: string;
  whiteBackground?: boolean;
  stepTrustHeaderText: StepTrustHeaderText[];
}

/**
 * Header for step container that displays trust-building texts.
 */
const UnstyledStepTrustHeader: FunctionComponent<StepTrustHeaderProp> = ({ className, stepTrustHeaderText }) => {
  return (
    <div className={className}>
      {map(stepTrustHeaderText, (headerText, idx) => {
        // Don't apply margin left for first and last text.
        const noMarginLeft = idx === 0 || idx === stepTrustHeaderText.length - 1;

        // Apply margin right for second last text.
        const marginRight = idx === stepTrustHeaderText.length - 2;

        return (
          <Box
            key={`step-header-${idx}`}
            color={headerText.bold ? 'default' : 'grey.250'}
            ml={noMarginLeft ? 0 : 0.5}
            mr={marginRight ? 0.5 : 0}
          >
            <Typography
              variant="subtitle1"
              className="trust-text"
              style={{ fontWeight: headerText.bold ? 700 : undefined }}
            >
              {headerText.text}
            </Typography>
          </Box>
        );
      })}
    </div>
  );
};

export const StepTrustHeader = styled(UnstyledStepTrustHeader)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 2.875rem;
  padding: 1rem 1.5rem;
  text-align: center;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;

  background-color: #f8f9fa;
  .trust-text {
    font-size: 12px;
  }
`;
